import React from "react";
import LandingPage from '../pages/LandingPage';
import { jsx as _jsx } from "react/jsx-runtime";
export var PrivateRoute = function PrivateRoute(_ref) {
  var children = _ref.children;
  return localStorage.getItem('isOn') == 'true' ? children : /*#__PURE__*/_jsx(LandingPage, {});
};